import { useEffect, useMemo, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { resolveAdminMediaUrl } from '@formosa/shared/utils/mediaUrl';
import AboutUsEditModal from './AboutUsEditModal';
import { hasAboutContent, mergeAboutDetailsWithLanguages } from './aboutUsConstants';

function MediaPreview({ detail }) {
  if (!hasAboutContent(detail)) {
    return <div className="about-us-card__empty">暫未設置</div>;
  }

  return (
    <div className="about-us-card__media">
      {detail.video ? (
        <video src={resolveAdminMediaUrl(detail.video)} controls playsInline className="about-us-card__video" />
      ) : null}
      {detail.image ? (
        <img src={resolveAdminMediaUrl(detail.image)} alt="" className="about-us-card__image" />
      ) : null}
    </div>
  );
}

export default function AboutUsPage() {
  const [records, setRecords] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [editOpen, setEditOpen] = useState(false);

  const mergedDetails = useMemo(
    () => mergeAboutDetailsWithLanguages(languages, records),
    [languages, records]
  );

  async function loadData() {
    setLoading(true);
    setError('');
    try {
      const [langList, aboutList] = await Promise.all([
        adminApi.newsLanguages(),
        adminApi.getAboutUs(),
      ]);
      setLanguages(Array.isArray(langList) ? langList : []);
      setRecords(Array.isArray(aboutList) ? aboutList : []);
    } catch (err) {
      setError(err.message || '載入失敗');
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  function handleSaved() {
    setMessage('修改成功');
    setEditOpen(false);
    loadData();
  }

  return (
    <div className="page-card">
      <div className="section-header">
        <h2>關於我們</h2>
        <div className="section-header__actions">
          <button type="button" className="btn btn-success" onClick={() => setEditOpen(true)}>
            修改
          </button>
        </div>
      </div>

      {message ? <p className="form-message form-message--success">{message}</p> : null}
      {error ? <p className="form-message form-message--error">{error}</p> : null}

      {loading ? (
        <p className="table-empty">載入中…</p>
      ) : (
        <div className="about-us-grid">
          {mergedDetails.map((detail) => (
            <article key={detail.lang} className="about-us-card">
              <header className="about-us-card__header">{detail._label || detail.lang}</header>
              <MediaPreview detail={detail} />
            </article>
          ))}
        </div>
      )}

      <AboutUsEditModal
        open={editOpen}
        initialDetails={records}
        languages={languages}
        onClose={() => setEditOpen(false)}
        onSaved={handleSaved}
      />
    </div>
  );
}
